import { Button, Dropdown, GenericWrapperContext } from "@cakemail-org/ui-components-v2"
import { useContext, useEffect } from "react"
import { SelectChangeEvent, Stack } from "@mui/material"
import { useTranslation } from "react-i18next"
import "./styles.scss"
import { TOnboardingIndustrySetup } from "./types"
import { OnboardingContext } from "../../context"
import { getIndustries, getIndustryCat, getTeamSize } from "./data"
import { TOnboardingIndustryForm } from "../../types"
export function OnboardingIndustrySetup({ }: TOnboardingIndustrySetup) {
    const onboardingContext = useContext(OnboardingContext)
    const { t } = useTranslation()

    useEffect(() => {
        const organization = onboardingContext.enrichedPerson?.organization
        if (organization) {
            const orgSector = onboardingContext.industryForm.sector || organization.industry?.replace(/ /g, "_")?.replace(/&/g, "and")?.replace(/,/g, "")
            //Find industry name by searching for sector in industry groups
            let industry = onboardingContext.industryForm.industry || ""
            for (const cat of getIndustryCat()) {
                if (getIndustries(cat.value).some(s => s.value === orgSector)) {
                    industry = cat.value
                    break
                }
            }
            onboardingContext.industryForm.industry = industry
            onboardingContext.industryForm.sector = orgSector

            //Find estimated team size if not set
            if (!onboardingContext.industryForm.teamSize) {
                const teamSize = getTeamSize().find((ts) => {
                    const employeeCount = organization.estimated_num_employees
                    const [min, max] = ts.value.split('-').map(n => parseInt(n))

                    if (ts.value.includes('-')) {
                        return employeeCount >= min && employeeCount <= max
                    } else {
                        return employeeCount <= parseInt(ts.value)
                    }
                })
                onboardingContext.industryForm.teamSize = teamSize?.value || "1"
            } else {
                onboardingContext.industryForm.teamSize = onboardingContext.industryForm.teamSize
            }

            onboardingContext.setIndustryForm({ ...onboardingContext.industryForm })
        }
    }, [])

    function handleDDChange(e: SelectChangeEvent<string>) {
        const { name, value } = e.target
        onboardingContext.industryForm[name as keyof TOnboardingIndustryForm] = value
        onboardingContext.setIndustryForm({ ...onboardingContext.industryForm })
    }

    function handleNext() {
        onboardingContext.handleNext()
    }

    const continueDisabled = !onboardingContext.industryForm.industry || !onboardingContext.industryForm.sector || !onboardingContext.industryForm.teamSize

    return <Stack direction="column" className="onboardingIndustrySetup" gap={9} flex={1}>
        <Dropdown
            size="large"
            name="industry"
            label={t("industry-cat-label")}
            placeholder={t("industry-cat-placeholder")}
            options={getIndustryCat()}
            onChange={handleDDChange}
            value={onboardingContext.industryForm.industry || ""}
        />
        <Dropdown
            size="large"
            name="sector"
            label={t("industry-sector-label")}
            placeholder={t("industry-sector-placeholder")}
            disabled={!onboardingContext.industryForm.industry}
            options={getIndustries(onboardingContext.industryForm.industry || "")}
            onChange={handleDDChange}
            value={onboardingContext.industryForm.sector || ""}
        />
        <Dropdown
            size="large"
            name="teamSize"
            label={t("industry-team-size-label")}
            placeholder={t("industry-team-size-placeholder")}
            options={getTeamSize()}
            onChange={handleDDChange}
            value={onboardingContext.industryForm.teamSize || ""}
        />

        <Stack direction="row" className="onboardingContent" justifyContent="flex-end" gap={4}>
            <Button variant="contained" color="secondary" onClick={handleNext} disabled={continueDisabled}>
                {t("general-continue")}
            </Button>
        </Stack>
    </Stack>
}

export default OnboardingIndustrySetup